import React, {memo } from 'react';
import { connect } from 'react-redux';
import GlobalLoader from './GlobalLoader';


const LoaderComponent = memo((props)=>{
    const {loading} = props;
    if(loading===true){
        return(
              <GlobalLoader />
        )
    }else{
        return <></>
    }
    
});

  const mapStateToProps = (state) => { 
    return {
      loading : state.commonReducer.loading,
    };
  }
  export default
    connect(
      mapStateToProps, 
      null
    )(LoaderComponent);